import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var ConfluenceInlineComment = /*#__PURE__*/function (_Component) {
  _inherits(ConfluenceInlineComment, _Component);
  var _super = _createSuper(ConfluenceInlineComment);
  function ConfluenceInlineComment() {
    _classCallCheck(this, ConfluenceInlineComment);
    return _super.apply(this, arguments);
  }
  _createClass(ConfluenceInlineComment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        reference = _this$props.reference,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement("span", {
        "data-mark-type": "confluenceInlineComment",
        "data-reference": reference
      }, children);
    }
  }]);
  return ConfluenceInlineComment;
}(Component);
export { ConfluenceInlineComment as default };